import { render, staticRenderFns } from "./ScrollLayout.vue?vue&type=template&id=ac061982&"
import script from "./ScrollLayout.vue?vue&type=script&lang=js&"
export * from "./ScrollLayout.vue?vue&type=script&lang=js&"
import style0 from "./ScrollLayout.vue?vue&type=style&index=0&id=ac061982&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports